import {AppCard} from "shared/components/mui";
import {Skeleton} from "@mui/material";

const PluginSkeleton = () => (
  <AppCard sx={{p: 3, width: 450}} bodyStyle={{p:0, m: 0}}>
    <Skeleton variant="rounded" sx={{width: '100%'}} height={170} />
  </AppCard>
)

export default PluginSkeleton;